import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    // CRITICAL: if returning from the OAuth callback, skip the /me check —
    // AuthCallback exchanges the session_id and establishes the session first.
    if (window.location.hash?.includes("session_id=")) return;
    if (!localStorage.getItem("te_token")) { setUser(false); return; }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("te_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (name, email, password, referralCode = "") => {
    const { data } = await api.post("/auth/register", { name, email, password, referral_code: referralCode });
    localStorage.setItem("te_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const completeAuth = useCallback((data) => {
    localStorage.setItem("te_token", data.token);
    setUser(data.user);
  }, []);

  const updateUser = useCallback((u) => setUser(u), []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("te_token");
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, login, register, completeAuth, updateUser, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
